import { Registry } from "@cf-design-system/registry";
import * as Icons from "./icons";
Registry.register(Icons, "ThemeIcons");
export { default as Icon } from "./Icon";